module.exports = __webpack_public_path__ + "img/dawn.d414cd4e.png";